import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

/**
 * AQ-50 patient self-report form entrypoint.
 *
 * Important implementation detail:
 * - We pass `formKey="aq50"` explicitly so the template selects the correct form
 *   from Firestore by key, rather than relying on matching `formTitle`.
 * - This is more robust long-term as we add more instruments and avoid title collisions.
 */
export default function PatientAQ50Form() {
  return (
    <PatientFormTemplate
      formTitle="Autism Spectrum Quotient (AQ-50)"
      formKey="aq50"
    />
  );
}

